module.exports = __webpack_public_path__ + "static/media/i4163457101.a02aada1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/i4163457101.jpg
// module id = 93
// module chunks = 0